export { GalaxyStyleModule } from './src/style.module';
export { GalaxyTheme, StyleService } from './src/style.service';
export { preferredTheme } from './src/style.service';
